import { Trans } from 'react-i18next'

import brainNervousSystemPNG from '~/assets/images/anatomy/brain-nervous-system.png'
import brainNervousSystemWEBP from '~/assets/images/anatomy/brain-nervous-system.webp'
import {
  ANSWERS,
  BRAIN_NERVOUS_SYSTEM_QUESTION,
  greenAccept,
  redCross,
} from '~/pages/anatomy/quizBinaryChoice/libs/constants'
import { useBinaryChoiceStep } from '~/shared/hooks/useBinaryChoiceStep'
import { TPageProps } from '~/shared/types/commonTypes'

import { Styles as S } from './styles'

const BrainNervousSystem = ({ pageId, nextPagePath }: TPageProps) => {
  const { answer, handleAnswer } = useBinaryChoiceStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: BRAIN_NERVOUS_SYSTEM_QUESTION,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <div>
          <S.Question>
            <Trans i18nKey="onboarding.quizBinaryChoice.quizWithImageTitle" />
          </S.Question>

          <S.CardWrapper>
            <S.Card>
              <S.ImageBackground>
                <picture>
                  <source srcSet={brainNervousSystemWEBP} type="image/webp" />
                  <img
                    src={brainNervousSystemPNG}
                    alt="Brain & Nervous System"
                  />
                </picture>
              </S.ImageBackground>

              <S.CardTextContent>
                <S.CardTitle>
                  <Trans i18nKey="onboarding.quizBinaryChoice.brainNervousSystemTitle" />
                </S.CardTitle>
                <S.CardSubtitle>
                  <Trans
                    i18nKey="onboarding.quizBinaryChoice.brainNervousSystemSubtitle"
                    components={{ br: <br /> }}
                  />
                </S.CardSubtitle>
              </S.CardTextContent>
            </S.Card>
          </S.CardWrapper>
        </div>

        <S.ButtonWrapper>
          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.no}
            onClick={() => handleAnswer(ANSWERS.no)}
          >
            <S.ButtonIcon src={redCross} alt={ANSWERS.no} />
            <Trans i18nKey={`actions.${ANSWERS.no}`} />
          </S.StyledButton>

          <S.StyledButton
            type="button"
            $isSelected={answer === ANSWERS.yes}
            onClick={() => handleAnswer(ANSWERS.yes)}
          >
            <S.ButtonIcon src={greenAccept} alt={ANSWERS.yes} />
            <Trans i18nKey={`actions.${ANSWERS.yes}`} />
          </S.StyledButton>
        </S.ButtonWrapper>
      </S.StyledContainer>
    </S.Root>
  )
}

export default BrainNervousSystem
